import {
  useEffect,
  useState
} from 'react'

import {
  FaCheck
} from 'react-icons/fa'

import {
  useAdmin
} from '../../../context/AdminContext'

import {
  AdminCard,
  Field,
  Input,
  Textarea,
  BtnPrimary
} from './AdminUI'

import {
  getContact,
  saveContact
} from '../../../api/portfolioApi'

export default function ContactEditor({
  onSaved
}) {

  // ───────────────────────────────────────────
  // Context
  // ───────────────────────────────────────────
  const {
    refreshPortfolio
  } = useAdmin()

  // ───────────────────────────────────────────
  // State
  // ───────────────────────────────────────────
  const [loading, setLoading] =
    useState(false)

  const [error, setError] =
    useState('')

  const [local, setLocal] =
    useState({
      email: '',
      phone: '',
      location: '',
      callout: ''
    })

  // ───────────────────────────────────────────
  // Load Contact Data
  // ───────────────────────────────────────────
  useEffect(() => {
    loadContactData()
  }, [])

  const loadContactData =
    async () => {

      try {

        setLoading(true)

        setError('')

        const data =
          await getContact()

        if (data) {

          setLocal({

            email:
              data.email ?? '',

            phone:
              data.phone ?? '',

            location:
              data.location ?? '',

            callout:
              data.callout ?? ''
          })
        }

      } catch (err) {

        console.error(err)

        setError(
          'Failed to load contact information'
        )

      } finally {

        setLoading(false)
      }
    }

  // ───────────────────────────────────────────
  // Update Field
  // ───────────────────────────────────────────
  const updateField = (
    key,
    value
  ) => {

    setLocal(prev => ({
      ...prev,
      [key]: value
    }))
  }

  // ───────────────────────────────────────────
  // Save Contact
  // ───────────────────────────────────────────
  const handleSave =
    async () => {

      try {

        setLoading(true)

        setError('')

        // Save to backend
        await saveContact(local)

        // Refresh global context
        await refreshPortfolio()

        onSaved?.(
          'Contact info updated!'
        )

      } catch (err) {

        console.error(err)

        setError(
          err.message
          || 'Failed to save contact info'
        )

      } finally {

        setLoading(false)
      }
    }

  // ───────────────────────────────────────────
  // UI
  // ───────────────────────────────────────────
  return (

    <AdminCard

      title="Contact Info"

      subtitle="
        Email, phone,
        location and callout text
      "
    >

      {/* Error */}
      {error && (

        <div
          className="
            mb-4
            rounded-xl
            border
            border-red-500/20
            bg-red-500/10
            px-4
            py-3
            text-sm
            text-red-400
          "
        >
          {error}
        </div>
      )}

      {/* Fields */}
      <div
        className="
          grid
          sm:grid-cols-2
          gap-4
        "
      >

        {/* Email */}
        <Field label="Email">

          <Input

            type="email"

            value={local.email}

            onChange={(e) =>
              updateField(
                'email',
                e.target.value
              )
            }

            placeholder="
              your@email.com
            "

            maxLength={150}
          />

        </Field>

        {/* Phone */}
        <Field label="Phone">

          <Input

            value={local.phone}

            onChange={(e) =>
              updateField(
                'phone',
                e.target.value
              )
            }

            placeholder="
              +91 XXXXXXXXXX
            "

            maxLength={30}
          />

        </Field>

        {/* Location */}
        <Field label="Location">

          <Input

            value={local.location}

            onChange={(e) =>
              updateField(
                'location',
                e.target.value
              )
            }

            placeholder="
              City, Country
            "

            maxLength={80}
          />

        </Field>

      </div>

      {/* Callout */}
      <Field label="Callout Text">

        <Textarea

          value={local.callout}

          onChange={(e) =>
            updateField(
              'callout',
              e.target.value
            )
          }

          rows={2}

          placeholder="
            Reach out for projects,
            collaborations or jobs...
          "
        />

      </Field>

      {/* Save */}
      <BtnPrimary

        onClick={handleSave}

        disabled={loading}
      >

        <FaCheck size={11} />

        {loading
          ? 'Saving...'
          : 'Save Contact'}

      </BtnPrimary>

    </AdminCard>
  )
}